module.exports = __webpack_public_path__ + "static/media/bunte_de.f7b1ea8c.jpg";